/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { jwtDecode } from "jwt-decode";
import Navbar from '../Navbar';
import Header from '../Header';
import baseUrl from '../BaseUrl';
import Loader from '../Loader';
import { useNavigate, Link } from 'react-router-dom';
import Pagination from 'react-js-pagination';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const getToday = () => {
  const d = new Date();
  return d.getFullYear() + '-' +
    (d.getMonth() + 1).toString().padStart(2, '0') + '-' +
    d.getDate().toString().padStart(2, '0');
};

const CloudwatchErrorLogs = () => {
  const today = getToday();
  const [name, setName] = useState('');
  const [token, setToken] = useState('');
  const [expire, setExpire] = useState('');
  const [popupOpen, setPopupOpen] = useState(false);
  const [data, setData] = useState([]);
  const [totalItem, setTotalItem] = useState(0);
  const [page, setPage] = useState(1);
  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);
  const [displayFromDate, setDisplayFromDate] = useState(new Date());
  const [displayToDate, setDisplayToDate] = useState(new Date());
  const [expandedRow, setExpandedRow] = useState(null);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const limit = 25;

  useEffect(() => {
    refreshToken();
  }, []);

  useEffect(() => {
    setName('Pauser');
    getData(1, today, today);
  }, []);

  const refreshToken = async () => {
    try {
      const response = await axios.get(`${baseUrl}/admin/api/token`);
      setToken(response.data.accessToken);
      const decoded = jwtDecode(response.data.accessToken);
      setExpire(decoded.exp);
    } catch (error) {
      if (error.response) {
        navigate('/');
        window.location.reload();
      }
    }
  };

  const axiosJWT = axios.create();

  axiosJWT.interceptors.request.use(async (config) => {
    const currentDate = new Date();
    if (expire * 1000 < currentDate.getTime()) {
      const response = await axios.get(`${baseUrl}/admin/api/token`);
      config.headers.Authorization = `Bearer ${response.data.accessToken}`;
      setToken(response.data.accessToken);
      const decoded = jwtDecode(response.data.accessToken);
      setExpire(decoded.exp);
    }
    return config;
  }, (error) => {
    return Promise.reject(error);
  });

  const getData = async (currentPage, from, to) => {
    setPopupOpen(true);
    setError('');
    try {
      const response = await axiosJWT.get(
        `${baseUrl}/admin/api/cloudwatch-error-logs?page=${currentPage}&limit=${limit}&from_date=${from}&to_date=${to}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setData(response.data.data);
      setTotalItem(response.data.totalItem);
    } catch (err) {
      console.error(err);
      setError('Unable to fetch logs. Please try again later.');
      setData([]);
      setTotalItem(0);
    }
    setPopupOpen(false);
  };

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
    setExpandedRow(null);
    getData(pageNumber, fromDate, toDate);
  };

  const handleFromDate = (date) => {
    if (!date) {
      setFromDate('');
      setDisplayFromDate('');
      return;
    }
    const formatted = date.getFullYear() + '-' +
      (date.getMonth() + 1).toString().padStart(2, '0') + '-' +
      date.getDate().toString().padStart(2, '0');
    setFromDate(formatted);
    setDisplayFromDate(date);
  };

  const handleToDate = (date) => {
    if (!date) {
      setToDate('');
      setDisplayToDate('');
      return;
    }
    const formatted = date.getFullYear() + '-' +
      (date.getMonth() + 1).toString().padStart(2, '0') + '-' +
      date.getDate().toString().padStart(2, '0');
    setToDate(formatted);
    setDisplayToDate(date);
  };

  const handleSearchSubmit = () => {
    if (fromDate && toDate && fromDate > toDate) {
      setError('From date cannot be after To date');
      return;
    }
    setPage(1);
    setExpandedRow(null);
    getData(1, fromDate, toDate);
  };

  const clearFilter = () => {
    setFromDate(today);
    setDisplayFromDate(new Date());
    setToDate(today);
    setDisplayToDate(new Date());
    setPage(1);
    setExpandedRow(null);
    setError('');
    getData(1, today, today);
  };

  const toggleRow = (index) => {
    setExpandedRow(expandedRow === index ? null : index);
  };

  const truncateMessage = (msg, maxLen = 80) => {
    if (!msg) return '—';
    return msg.length > maxLen ? msg.substring(0, maxLen) + '...' : msg;
  };

  return (
    <div className="panelbox">
      <Navbar />
      <div className="right-panel">
        <Header name={name} />
        {popupOpen && <Loader />}
        <div className="content-page">
          <div className="row">
            <div className="col-6">
              <div className="left-title">
                <h1>CloudWatch Error Logs</h1>
              </div>
            </div>
            <div className="col-6">
              <div className="addnew-button">
                <Link to="/dashboard"><span>&larr;</span> Back</Link>
              </div>
            </div>
          </div>
          <div className="row numberboxes">
            <div className="col-md-3">
              <div className="dashboard-box" id="number">
                <h3>Total Logs</h3>
                <p>{totalItem}</p>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12 order-filter transection-filter">
              <div className="boxinput">
                <DatePicker
                  selected={displayFromDate}
                  onChange={handleFromDate}
                  dateFormat="dd/MM/yyyy"
                  placeholderText="From Date"
                  className="from-date"
                />
                <DatePicker
                  selected={displayToDate}
                  onChange={handleToDate}
                  dateFormat="dd/MM/yyyy"
                  placeholderText="To Date"
                  className="end-date"
                />
                <button className="search-btn" onClick={handleSearchSubmit}>Search</button>
                {(fromDate !== today || toDate !== today) && (
                  <button type="button" className="search-btn clear-btn" onClick={clearFilter}>Clear</button>
                )}
              </div>
            </div>
          </div>

          {error && <div className="row"><div className="col-12"><p style={{ color: 'red', padding: '10px 0' }}>{error}</p></div></div>}

          <div className="row">
            <div className="col-12">
              <div className="fullwidth-table track-table-body staff-listing-admin-table-body">
                <table className="table is-striped is-fullwidth">
                  <thead>
                    <tr>
                      <th>Timestamp</th>
                      <th>Level</th>
                      <th>Message</th>
                      <th>User ID</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data && data.length > 0 ? (
                      data.map((item, index) => (
                        <React.Fragment key={index}>
                          <tr onClick={() => toggleRow(index)} style={{ cursor: 'pointer' }}>
                            <td data-label="Timestamp">{item.timestamp}</td>
                            <td data-label="Level">{item.level}</td>
                            <td data-label="Message">{truncateMessage(item.message)}</td>
                            <td data-label="User ID">{item.user_id || '—'}</td>
                          </tr>
                          {expandedRow === index && (
                            <tr className="expanded-row">
                              <td colSpan="4" style={{ padding: '15px', backgroundColor: '#f9f9f9' }}>
                                <strong>Full Message:</strong>
                                <p style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{item.message}</p>
                                <strong>Raw Metadata:</strong>
                                <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', maxHeight: '300px', overflow: 'auto' }}>
                                  {JSON.stringify(item.raw, null, 2)}
                                </pre>
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      ))
                    ) : (
                      !popupOpen && !error && (
                        <tr>
                          <td colSpan="4" style={{ textAlign: 'center', padding: '20px' }}>
                            {fromDate || toDate
                              ? 'No error logs found for the selected date range.'
                              : 'No error logs found for today.'}
                          </td>
                        </tr>
                      )
                    )}
                  </tbody>
                </table>
                {totalItem > limit && (
                  <Pagination
                    activePage={page}
                    itemsCountPerPage={limit}
                    totalItemsCount={totalItem}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange.bind(this)}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CloudwatchErrorLogs;
